import React from "react";
import i18n from "i18next";


export const PublishTag: React.FC<boolean> = (isPublished) => {
    if (isPublished){
        return <>{i18n.t("publish.published")}</>
    }
    return <>{i18n.t("publish.draft")}</>
}